import script from "./NavElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavElement.vue?vue&type=script&setup=true&lang=ts"

import "./NavElement.vue?vue&type=style&index=0&id=a3a46cce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3a46cce"]])

export default __exports__